import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { addressesAPI } from "api/Community/AddressesAPI";

interface AddAddressesPopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newAddress: any) => void;
}

const AddAddressesPopup: React.FC<AddAddressesPopupProps> = ({
  open,
  onClose,
  onSaved,
}) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Address"
      createFunction={addressesAPI.create}
      fields={[
        {
          name: "street_address",
          label: "Street Address",
          required: true,
          type: "address_autocomplete",
        },
        { name: "city", label: "City / Town", required: true },
        { name: "state", label: "County / State" },
        { name: "post_code", label: "Postcode", required: true },
        { name: "country", label: "Country", required: true },
      ]}
      onSaved={onSaved}
    />
  );
};


export default AddAddressesPopup;
